import { getDefaultStore } from 'jotai';
import { regionAtom } from '../store';
import { currentLanguage } from '../i18n';

// Dates, times and numbers the Indian way by default: "22 Oct 2026",
// "8:56 pm", 1,00,000 (docs/indian-touches.md, D145). People elsewhere can
// switch to their device's own region in Settings → Language & region.

/** The locale every date, time and number in the app is formatted with. */
export function appLocale(): string | undefined {
  const india = getDefaultStore().get(regionAtom) === 'IN';
  // Hindi (D146) writes months in Devanagari: 22 अक्तू॰ 2026.
  if (currentLanguage() === 'hi') return india ? 'hi-IN' : 'hi';
  return india ? 'en-IN' : undefined;
}

/** "8:56 pm" (India) or the device's own style. */
export function formatClock(date: Date, locale = appLocale()): string {
  return date.toLocaleTimeString(locale, {
    hour: 'numeric',
    minute: '2-digit',
  });
}

/** "22 Oct 2026" (India) or the device's own style. */
export function formatDate(date: Date, locale = appLocale()): string {
  return date.toLocaleDateString(locale, {
    day: 'numeric',
    month: 'short',
    year: 'numeric',
  });
}

/** 1,00,000 (India) or the device's own grouping. */
export function formatNumber(value: number, locale = appLocale()): string {
  return value.toLocaleString(locale);
}
